import type { ReportFilters, ReportSummary, ReportDetail } from '../../../modules/reports/context/ReportContext';
import { api } from '../../../shared/services/api';
import { v4 as uuidv4 } from 'uuid';

export const reportService = {
  async getReports(filters: ReportFilters): Promise<{ summary: ReportSummary; details: (ReportDetail & { id: string })[] }> {
    const params = {
      type: filters.type.toLowerCase(),
      period: filters.period,
      startDate: filters.startDate,
      endDate: filters.endDate,
    };
    const response = await api.get('/reports/summary', { params });
    const { summary, details } = response.data;
    // Garante que cada item de details tem um id único
    const detailsWithId = (details || []).map((item: any) => ({
      ...item,
      id: item.id || uuidv4(),
    }));
    return { summary, details: detailsWithId };
  },
};

export const handlePdf = async (row: any) => {
  const getEndpoint = pdfEndpointMap[row.type];
  if (!getEndpoint) {
    alert('Tipo de relatório não suportado para PDF');
    return;
  }
  const url = getEndpoint(row.id);
  try {
    const response = await api.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', `${row.type.toLowerCase()}-${row.id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (e) {
    alert('Erro ao gerar PDF');
  }
};

export const handleReportTypePdf = async (filters: ReportFilters, type: string) => {
  try {
    const params = {
      type: type.toLowerCase(),
      period: filters.period,
      startDate: filters.startDate,
      endDate: filters.endDate,
    };
    const response = await api.get('/reports/pdf', { params, responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', `relatorio-${type.toLowerCase()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (e) {
    alert('Erro ao gerar PDF do relatório');
  }
};

const pdfEndpointMap: Record<string, (id: string) => string> = {
  Morador: (id) => `/reports/residents/${id}/pdf`,
  Visitante: (id) => `/reports/visitors/${id}/pdf`,
  Reserva: (id) => `/reports/reservations/${id}/pdf`,
  Reservas: (id) => `/reports/reservations/${id}/pdf`,
};